import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsOptional } from 'class-validator';


export class BankNamesDTO {
  @ApiProperty()
  @IsNotEmpty()
  id: number;


  @ApiProperty()
  @IsNotEmpty()

  bankName: string;
 

  
  @ApiProperty()
  @IsNotEmpty()
  createdUser: string ;


  @ApiProperty()
  @IsOptional()
  createdAt: Date;


  @ApiProperty()
  updatedAt: Date;

  @ApiProperty()
  @IsNotEmpty()
  updatedUser: string ;
}
